'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res11 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res11, _Component);

  function Module2Res11() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res11);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res11.__proto__ || (0, _getPrototypeOf2.default)(Module2Res11)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 4',
      title: 'Useful links',
      links: [{
        name: 'Dietitians Association of Australia',
        website: 'daa.asn.au/for-the-public/smart-eating-for-you/recipes/browse/',
        tagline: 'Try the Thai beef salad, pesto and zucchini spaghetti and bircher muesli recipes!',
        description: 'Plenty of dietitian-approved family recipes all in one place. You can search for type of ' + 'cuisine, gluten-free and low salt options, kid-friendly recipes and more.'
      }, {
        name: 'Nutrition Australia',
        website: 'www.nutritionaustralia.org/national/recipes',
        tagline: 'Try the red kidney bean burritos, bubble and squeak slice or breakfast smoothie recipes!',
        description: 'Breakfast, lunch, dinner, sweets, snacks, salads, soups and condiment recipes.'
      }, {
        name: 'Cancer Council NSW',
        website: 'www.cancercouncil.com.au/cancer-prevention/diet-exercise/eat-it-to-beat-it/recipes-healthy-family-meals/',
        tagline: 'Try the vegie lasagne, sang choy bow or carrot and parsnip muffins recipes!',
        description: 'Hundreds of recipe ideas for breakfast, lunch, dinner, healthy desserts and snacks'
      }, {
        name: 'Healthy Food Magazine',
        website: 'www.healthyfoodguide.com.au/',
        tagline: 'Try ham and tomato soufflè omelette, Mexican pizza and chick\'n\'veg skewers recipes!',
        description: 'Search hundreds of healthy recipes for the whole family by season, special diets, meals and ' + 'occasions, quick meals, kid-friendly meals and many more.'
      }, {
        name: 'Heart Foundation',
        website: 'heartfoundation.org.au/recipes',
        tagline: 'Try the beany melts, beef and lentil bolognaise and banana pikelets!',
        description: 'Have a browse through plenty of Heart Foundation approved recipes or search by main ingredient or cooking ' + 'style.'
      }, {
        name: 'Healthy Kids, NSW Ministry of Health',
        website: 'www.healthykids.nsw.gov.au/recipes',
        tagline: 'Try the salmon, ricotta and quinoa cups, veggie quesadillas or berry swirl yoghurt pops!',
        description: 'Nutritious, tasty, quick and easy to prepare recipes designed specifically for families.'
      }, {
        name: 'Good for Kids',
        website: 'www.goodforkids.nsw.gov.au/parents-carers/children-0-5-yrs/packing-healthy-lunchboxes/',
        tagline: 'Try the pork and vegetable meatballs, berry and ricotta muffins or vegetable slice!',
        description: 'Plenty of suggestions for quick and healthy snacks, lunch box meals and more. Information ' + 'is best suited to kids under 5 years.'
      }, {
        name: 'One Handed Cooks',
        website: 'onehandedcooks.com.au',
        tagline: 'Try the budget beef and noodle stir fry, pick \'n\' Mix Veggie Pasta Bake or sushi sandwiches!',
        description: 'A food blog designed for parents of babies, toddlers and primary-schoolers. The recipes are all quick, ' + 'easy to make and nutritious.'
      }, {
        name: 'Jamie Oliver\'s Website',
        website: 'www.jamieoliver.com/recipes/category/healthy-recipes',
        tagline: '',
        description: ''
      }, {
        name: 'Taste Website',
        website: 'www.taste.com.au/recipes/collections/groups/healthy+recipes',
        tagline: '',
        description: ''
      }]
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module2Res11, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'p',
                  null,
                  'Here are some websites that you might be interested in that provide useful information about children\'s health, including healthy dietary habits.'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  this.state.links.map(function (item) {
                    return _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'h4',
                          null,
                          item.name
                        ),
                        _react2.default.createElement(
                          'p',
                          null,
                          item.description
                        ),
                        _react2.default.createElement(
                          'a',
                          { target: '_blank', href: "//" + item.website },
                          item.tagline
                        )
                      )
                    );
                  })
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res11;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res11;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res11.js
// module id = 1238
// module chunks = 0